/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type GuestSquareBoard_getFrontGuestSquareBoardData$ref: FragmentReference;
declare export opaque type GuestSquareBoard_getFrontGuestSquareBoardData$fragmentType: GuestSquareBoard_getFrontGuestSquareBoardData$ref;
export type GuestSquareBoard_getFrontGuestSquareBoardData = {|
  +getFrontGuestSquareBoardData: ?{|
    +code: ?number,
    +message: ?string,
    +data: ?{|
      +_id: ?number,
      +guest_name: ?string,
      +allowed_squares: ?number,
      +number_of_selected_squares: ?number,
      +responses: ?$ReadOnlyArray<?{|
        +_id: ?number,
        +square: ?string,
        +guest_id: ?number,
      |}>,
    |},
  |},
  +$refType: GuestSquareBoard_getFrontGuestSquareBoardData$ref,
|};
export type GuestSquareBoard_getFrontGuestSquareBoardData$data = GuestSquareBoard_getFrontGuestSquareBoardData;
export type GuestSquareBoard_getFrontGuestSquareBoardData$key = {
  +$data?: GuestSquareBoard_getFrontGuestSquareBoardData$data,
  +$fragmentRefs: GuestSquareBoard_getFrontGuestSquareBoardData$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "_id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "GuestSquareBoard_getFrontGuestSquareBoardData",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "event_token",
      "type": "String!",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "guest_token",
      "type": "String!",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "game_id",
      "type": "ID!",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "question_id",
      "type": "ID!",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "getFrontGuestSquareBoardData",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "event_token",
          "variableName": "event_token"
        },
        {
          "kind": "Variable",
          "name": "game_id",
          "variableName": "game_id"
        },
        {
          "kind": "Variable",
          "name": "guest_token",
          "variableName": "guest_token"
        },
        {
          "kind": "Variable",
          "name": "question_id",
          "variableName": "question_id"
        }
      ],
      "concreteType": "frontGuestSquareBoardType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "code",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "message",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "data",
          "storageKey": null,
          "args": null,
          "concreteType": "frontGuestSquareBoardDataType",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "guest_name",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "allowed_squares",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "number_of_selected_squares",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "responses",
              "storageKey": null,
              "args": null,
              "concreteType": "returnSquareGuestData",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "square",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "guest_id",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '89aa868740a0f4b3166c95d5c072dd3f';
module.exports = node;
